import Model from './model.js';

export default class Bank extends Model {
    urlRoot() { return '/Banks'; }

    constructor() {
        super(...arguments);
        this.softDelete = false;
    }

    initialize() {
        this.idAttribute = 'objectId';
        return super.initialize(...arguments);
    }
}



// WEBPACK FOOTER //
// ./app/new-models/bank.js